module.exports = __webpack_public_path__ + "static/robinWilliams-bb2257451cb38c79c743a48d2d082ea1.jpg";